
import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject } from '@/core/di/Inject';
import { ValidationObserver } from 'vee-validate/dist/types/components';
import { TYPES } from '@/core/config/Types';
import { PriceListUpdateVolume } from '@/settings/application/uses_cases/priceList/update/volume/PriceListUpdateVolume';
import { PriceListFindAllByStatusVolume } from '@/settings/application/uses_cases/priceList/search/volume/PriceListFindAllByStatusVolume';
import { PriceListFindAllVolume } from '@/settings/application/uses_cases/priceList/search/volume/PriceListFindAllVolume';
import { PriceListUpdateWeight } from '@/settings/application/uses_cases/priceList/update/weight/PriceListUpdateWeight';
import { PriceListFindAllWeight } from '@/settings/application/uses_cases/priceList/search/weight/PriceListFindAllWeight';
import { PriceListFindAllByStatusWeight } from '@/settings/application/uses_cases/priceList/search/weight/PriceListFindAllByStatusWeight';
import { RouteFindById } from '@/settings/application/uses_cases/routes/search/RouteFindById';
import { PriceListCreateVolume } from '@/settings/application/uses_cases/priceList/create/volume/PriceListCreateVolume';
import { PriceListCreateWeight } from '@/settings/application/uses_cases/priceList/create/weight/PriceListCreateWeight';
import { PalletsFactorFindAll } from '@/settings/application/uses_cases/palletsFactor/search/PalletsFactorFindAll';
import FilterCustomize from '@/core/components/shared/FilterCustomize.vue';
import i18n from '@/core/plugins/i18n';
import { TaxeFindByStatus } from '@/settings/application/uses_cases/taxe/search/TaxeFindByStatus';
import { VolumeFindAll } from '@/settings/application/uses_cases/volume/search/VolumeFindAll';
import { WeightFindAll } from '@/settings/application/uses_cases/weight/search/WeightFindAll';
import { FindCommodityTypeByStatus } from '@/freight/application/commodity_type/search/FindCommodityTypesByStatus';
import { EntityFindFilter } from '@/settings/application/uses_cases/entity/search/EntityFindFilter';
import { CreateCommodityType } from '@/freight/application/commodity_type/create/CreateCommodityType';
import { UpdateCommodityType } from '@/freight/application/commodity_type/update/UpdateCommodityType';
import { RoutesFindByStatus } from '@/settings/application/uses_cases/routes/search/RoutesFindByStatus';
import { CommodityType } from '@/freight/domain/commodity_type/CommodityType';
import { PricingZoneFindByStatus } from '@/settings/application/uses_cases/PricingZone/search/PricingZoneFindByStatus';
import { PricingZone } from '@/settings/domain/PricingZone/PricingZone';

@Component({
  name: 'PriceList',
  components: { FilterCustomize }
})
export default class PriceList extends Vue {
  @Inject(TYPES.UPDATE_PRICE_LIST_VOLUME)
  readonly priceListUpdateVolume!: PriceListUpdateVolume;
  @Inject(TYPES.FINDALL_PRICE_LIST_VOLUME)
  readonly priceListFindAllVolumecall!: PriceListFindAllVolume;
  @Inject(TYPES.FINDBYSTATUS_PRICE_LIST_VOLUME)
  readonly priceListFindAllByStatusVolumecall!: PriceListFindAllByStatusVolume;
  @Inject(TYPES.UPDATE_PRICE_LIST_WEIGHT)
  readonly priceListUpdateWeight!: PriceListUpdateWeight;
  @Inject(TYPES.FINDALL_PRICE_LIST_WEIGHT)
  readonly priceListFindAllWeightcall!: PriceListFindAllWeight;
  @Inject(TYPES.FINDBYSTATUS_PRICE_LIST_WEIGHT)
  readonly priceListFindAllByStatusWeightcall!: PriceListFindAllByStatusWeight;
  @Inject(TYPES.FINDBYSTATUS_ROUTES)
  readonly routesActive!: RoutesFindByStatus;
  @Inject(TYPES.FINDBYID_ROUTES)
  readonly routeFindByIdcall!: RouteFindById;
  @Inject(TYPES.CREATE_PRICE_LIST_VOLUME)
  readonly priceListCreateVolume!: PriceListCreateVolume;
  @Inject(TYPES.CREATE_PRICE_LIST_WEIGHT)
  readonly priceListCreateWeight!: PriceListCreateWeight;
  @Inject(TYPES.FINDBYSTATUS_TAXE)
  readonly taxeFindByStatus!: TaxeFindByStatus;
  @Inject(TYPES.FINDALL_PALLETSFACTOR)
  readonly PalletsFactorFindAll!: PalletsFactorFindAll;
  @Inject(TYPES.FINDALL_VOLUME) readonly volumeFindAll!: VolumeFindAll;
  @Inject(TYPES.FINDALL_WEIGHT) readonly weightFindAll!: WeightFindAll;
  @Inject(TYPES.COMMODITY_TYPE_FIND_BY_STATUS)
  readonly findCommodityByStatus!: FindCommodityTypeByStatus;
  @Inject(TYPES.ENTITY_FIND_BY_DESCRIPTION_LIKE)
  readonly findAllCustomersLike!: EntityFindFilter;
  @Inject(TYPES.COMMODITY_TYPE_SAVE)
  readonly saveCommodityType!: CreateCommodityType;
  @Inject(TYPES.COMMODITY_TYPE_UPDATE)
  readonly updateCommodity!: UpdateCommodityType;
  @Inject(TYPES.PRICING_ZONE_FIND_BY_STATUS)
  readonly findActivePricingZones!: PricingZoneFindByStatus;

  //LISTAS
  pricingZonesList: PricingZone[] = [];

  //DATA
  target = i18n.t('menu.Price Lists');
  isLoading = false;
  filterParams = false;
  fullPage = true;
  priceVolumeKey = 0;
  priceWeightKey = 0;
  customersList = [];
  commodityList = [] as any;
  priceListVolume = [];
  priceListWeight = [];
  typeTransportList = [];
  routes = [];
  taxes = [];
  totalRows = 1;
  isDisabled = false;
  currentPageVolume = 1;
  currentPageWeigth = 1;
  perPage = 10;
  filter = null;
  filterOn = [];
  sortBy = 'age';
  sortDesc = false;
  provinceFrom = [];
  provinceTo = [];
  zonesFrom = [];
  zonesTo = [];
  volumeList = [];
  weightList = [];
  reportedList = [];
  isBusyVolume = true;
  isBusyWeight = true;
  isSave = true;
  isTouched: boolean | undefined;
  listroutestogether: any = {};
  route: any = null;
  currentPage = 0;
  form: any = {
    priceListCountryFrom: [],
    priceListCountryTo: [],
    priceListStateFrom: [],
    priceListStateTo: [],
    priceListZoneFrom: [],
    priceListZoneTo: [],
    priceListUnitValue: '',
    priceListMinRate: '',
    priceListType: [],
    entity: '',
    commodity: [],
    slidingScaleFrom: 0,
    slidingScaleTo: 0,
    dataTypeTransport: null,
    modelVolume: [],
    modelWeight: [],
    modelReporteIn: null,
    priceListTaxes: [],
    id: '',
    palletsFactor: '',
    status: true,
    ide: 0,
    pricingZone: null
  };
  useScale = true;
  $refs!: {
    formWizardPriceList: HTMLFormElement;
    priceListUnitValue: HTMLInputElement;
    dataTypeTransport: HTMLFormElement;
    validationPriceList: InstanceType<typeof ValidationObserver>;
  };
  //-- LIFE CYCLES
  created() {
    this.$nextTick(() => this.priceListFindAllVolume());
    this.$nextTick(() => this.priceListFindAllWeight());
    this.$nextTick(() => this.getAllCommodityActive());
    this.$nextTick(() => this.transportFindAll());
    this.$nextTick(() => this.volumeFindAllList);
    this.$nextTick(() => this.weightFindAllList);
    this.findPricelistZones();
  }
  mounted() {
    this.$nextTick(() => this.$refs.formWizardPriceList.activateAll());
  }
  //Computed
  get fields() {
    return [
      { key: 'action', label: this.translateCol('action'), sortable: false, stickyColumn: true },
      { key: 'id', label: 'Id', sortable: true },
      { key: 'zone.name', label: this.translateCol('pricingZone'), sortable: true },
      { key: 'entity.fullName', label: this.translateCol('supplier'), sortable: true },
      { key: 'commodity', label: this.translateCol('commodity'), sortable: true },
      { key: 'slidingScaleFrom', label: this.translateCol('slidingScale'), sortable: true, class: 'col-md-2' },
      { key: 'unitValue', label: this.translateCol('value'), sortable: true },
      { key: 'minRate', label: this.translateCol('rate'), sortable: true },
      { key: 'transportName', label: this.translateCol('typetransport'), sortable: true },
      { key: 'factor', label: this.translateCol('palletsFactor'), sortable: true },
      { key: 'active', label: this.translateCol('active'), sortable: true }
    ];
  }
  transportFindAll() {
    this.PalletsFactorFindAll.execute()
      .then((response: any) => {
        if ('code' in response && response.code == 404) {
          this.typeTransportList = [];
          return;
        }
        this.typeTransportList = response;
        this.$emit('response-transport', response);
      })
      .catch(error => {
        this.typeTransportList = [];
        throw new Error(error);
      });
  }
  get volumeFindAllList() {
    this.volumeFindAll
      .execute()
      .then((response: any) => {
        this.volumeList = response;
      })
      .catch(error => {
        throw new Error(error);
      });
    return this.volumeList;
  }
  get weightFindAllList() {
    this.weightFindAll
      .execute()
      .then((response: any) => {
        this.weightList = response;
        this.reportedList = response;
      })
      .catch(error => {
        throw new Error(error);
      });
    return this.weightList;
  }
  get rowsVolume() {
    return this.priceListVolume.length;
  }
  get rowsWeight() {
    return this.priceListWeight.length;
  }
  //Methods

  translateCol(colName: string) {
    return this.$i18n.t('general.' + colName);
  }
  onFiltered(filteredItems: any) {
    this.totalRows = filteredItems.length;
    this.currentPage = 1;
  }
  getValidationState({ dirty, validated, valid = null }: { dirty: any; validated: any; valid: any }) {
    return dirty || validated ? valid : null;
  }
  priceListFindAllVolume() {
    this.priceListFindAllVolumecall
      .execute()
      .then((response: any) => {
        this.priceListVolume = response.reverse();
        this.isBusyVolume = false;
        this.priceVolumeKey += 1;
      })
      .catch((error: any) => {
        this.priceVolumeKey += 1;
        this.isBusyVolume = false;
        this.priceListVolume = [];
        throw new Error(error);
      });
  }
  priceListFindAllWeight() {
    this.priceListFindAllWeightcall
      .execute()
      .then((response: any) => {
        this.priceListWeight = response.reverse();
        this.isBusyWeight = false;
        this.priceWeightKey += 1;
      })
      .catch(() => {
        this.priceWeightKey += 1;
        this.isBusyWeight = false;
        this.priceListWeight = [];
      });
  }
  priceListFindAllByStatusVolume(status: boolean) {
    if (status || !status) {
      this.priceListFindAllByStatusVolumecall
        .execute(status)
        .then((response: any) => {
          this.filterParams = true;
          this.priceListVolume = response;
          this.isBusyVolume = false;
        })
        .catch((error: any) => {
          this.filterParams = false;
          this.isBusyVolume = false;
          this.priceListVolume = [];
          throw new Error(error);
        });
    } else {
      this.filterParams = false;
      this.priceListFindAllVolume();
    }
  }
  priceListFindAllByStatusWeight(status: boolean) {
    if (status || !status) {
      this.priceListFindAllByStatusWeightcall
        .execute(status)
        .then((response: any) => {
          this.filterParams = true;
          this.priceListWeight = response;
          this.isBusyWeight = false;
        })
        .catch((error: any) => {
          this.filterParams = false;
          this.priceListWeight = [];
          throw new Error(error);
        });
    } else {
      this.filterParams = false;
      this.priceListFindAllWeight();
    }
  }
  preparePriceListUpdate(RowI: any, Mode: string) {
    if (Mode === 'update') {
      this.form.commodity = RowI.item.commodity;
      this.form.pricingZone = RowI.item.zone;
      this.form.entity = RowI.item.entity;
      this.form.slidingScaleFrom = RowI.item.slidingScaleFrom;
      this.form.slidingScaleTo = RowI.item.slidingScaleTo;
      this.useScale = RowI.item.slidingScaleTo == 0 && RowI.item.slidingScaleFrom == 0 ? false : true;
      this.passingRouteId(RowI);
      this.priceListVolumenesByRow(RowI);
    } else {
      this.setListTypeSave();
    }
    this.routesFindAll();
    this.getAllCommodityActive();
    this.taxesFindAll();
    this.transportFindAll();
  }
  //aqui
  passingRouteId(RowI: any) {
    this.route = { id: RowI.item.routeId, description: RowI.item.routeDescription || '' };
    this.listroutestogether = RowI.item;
  }
  routesFindAll() {
    this.routesActive
      .execute(true)
      .then((response: any) => {
        this.routes = response;
      })
      .catch(error => {
        throw new Error(error);
      });
  }
  taxesFindAll() {
    this.taxeFindByStatus
      .execute(true)
      .then((response: any) => {
        this.taxes = response;
      })
      .catch(error => {
        throw new Error(error);
      });
  }
  routeFindById(route: any) {
    this.routeFindByIdcall
      .execute(route.id)
      .then((response: any) => {
        this.route = response;
        this.listroutestogether = response;
        this.listroutestogether.routeId = this.listroutestogether.id;
        this.$refs.priceListUnitValue.focus();
      })
      .catch(error => {
        throw new Error(error);
      });
  }
  //evento de actualizacion o insert
  handleSubmit(e: any) {
    e.preventDefault();

    //aqui
    const payload = {
      routeId: parseFloat(this.listroutestogether.routeId),
      countryDestination: this.listroutestogether.countryDestination,
      countryOrigin: this.listroutestogether.countryOrigin,
      stateDestination: this.listroutestogether.stateDestination,
      stateOrigin: this.listroutestogether.stateOrigin,
      minRate: parseFloat(this.form.priceListMinRate),
      transportId: this.form.dataTypeTransport.code,
      transportName: this.form.dataTypeTransport.description,
      factor: this.form.priceListType.code !== 'weight' ? this.form.palletsFactor : 0,
      weightUnit: this.form.modelWeight.id,
      volumeUnit: this.form.modelVolume.id,
      range: '0',
      type: 'U',
      unitValue: parseFloat(this.form.priceListUnitValue),
      id: this.form.id || 0,
      taxes: this.form.priceListTaxes,
      active: this.form.status,
      zoneZcOrigin: this.listroutestogether.zoneZcOrigin,
      zoneZcDestination: this.listroutestogether.zoneZcDestination,
      reportedIn: this.form.modelReporteIn.code,
      entity: this.form.entity,
      zone: this.form.pricingZone,
      commodity: this.form.commodity,
      slidingScaleFrom: this.useScale ? this.form.slidingScaleFrom : 0,
      slidingScaleTo: this.useScale ? this.form.slidingScaleTo : 0,
      useScale: this.useScale
    };
    const arrayTaxes = [];
    for (const taxesData of this.form.priceListTaxes) {
      arrayTaxes.push({
        id: taxesData.id,
        taxCode: taxesData.code,
        taxName: taxesData.description,
        taxPercentage: taxesData.percentage
      });
    }
    payload.taxes = arrayTaxes;
    const noConfig =
      this.form.priceListType.code != 'weight'
        ? this.priceListVolume.filter((item: any) => {
            return (
              item.entity.id === this.form.entity.id &&
              item.commodity.id === this.form.commodity.id &&
              item.routeId === this.route.routeId
            );
          })
        : this.priceListWeight.filter((item: any) => {
            return (
              item.entity != null &&
              item.entity.id === this.form.entity.id &&
              item.commodity.id === this.form.commodity.id &&
              item.routeId === this.route.routeId
            );
          });

    const findNoScale =
      noConfig.filter((item: any) => {
        return item.slidingScaleFrom === 0 && item.slidingScaleTo === 0;
      }).length > 0;

    if (
      (this.useScale && !findNoScale && noConfig.length > 0) ||
      (!this.useScale && findNoScale && noConfig.length > 0) ||
      noConfig.length < 1
    ) {
      if (!this.isSave) {
        if (this.form.priceListType.code === 'weight') {
          //funcion que actualiza lista de precion weigth
          this.PriceListUpdateWeight(payload);
        } else if (this.form.priceListType.code === 'volume') {
          // funcion que actualiza lista de precios volume
          this.PriceListUpdateVolume(payload);
        }
      } else {
        if (this.form.priceListType.code === 'weight') {
          //save de lista de precios weight
          this.PriceListCreateWeight(payload);
        } else if (this.form.priceListType.code === 'volume') {
          // save de lista de precios volume
          this.PriceListCreateVolume(payload);
        }
      }
    } else {
      if (!this.useScale) {
        this.$swal(
          `${this.$t('general.scaleRegisterN')}`,
          `${this.$t('general.scaleRegisterNDescription')}`,
          'warning'
        );
      } else {
        this.$swal(`${this.$t('general.scaleRegister')}`, `${this.$t('general.scaleRegisterDescription')}`, 'warning');
      }
      return;
    }
  }

  //update services for price list
  PriceListUpdateWeight(payload: any) {
    this.isLoading = true;
    this.priceListUpdateWeight
      .execute(payload)
      .then((response: any) => {
        this.isLoading = false;
        this.priceListFindAllWeight();
        this.clearForm();
        return response;
      })
      .catch((error: any) => {
        this.isLoading = false;
        throw new Error(error);
      });
  }
  PriceListUpdateVolume(payload: any) {
    this.isLoading = true;
    this.priceListUpdateVolume
      .execute(payload)
      .then((response: any) => {
        this.isLoading = false;
        this.priceListFindAllVolume();
        this.clearForm();
        return response;
      })
      .catch((error: any) => {
        this.isLoading = false;
        throw new Error(error);
      });
  }

  //create services for price list
  PriceListCreateWeight(payload: any) {
    this.isLoading = true;
    this.priceListCreateWeight
      .execute(payload)
      .then((response: any) => {
        this.isLoading = false;
        this.priceListFindAllWeight();
        this.clearForm();
        return response;
      })
      .catch((error: any) => {
        this.isLoading = false;
        throw new Error(error);
      });
  }
  PriceListCreateVolume(payload: any) {
    this.isLoading = true;
    this.priceListCreateVolume
      .execute(payload)
      .then((response: any) => {
        this.isLoading = false;
        this.priceListFindAllVolume();
        this.clearForm();
        return response;
      })
      .catch((error: any) => {
        this.isLoading = false;
        throw new Error(error);
      });
  }

  priceListVolumenesByRow(row: any) {
    this.form.priceListUnitValue = row.item.unitValue;
    this.form.dataTypeTransport = { code: row.item.transportId, description: row.item.transportName };
    this.form.palletsFactor = row.item.factor;
    this.form.priceListMinRate = row.item.minRate;
    this.form.priceListCountryTo = { name: row.item.countryDestinationName, code: row.item.countryDestination };
    this.form.priceListCountryFrom = { name: row.item.countryOriginName, code: row.item.countryOrigin };
    this.form.priceListStateTo = { name: row.item.stateDestinationName, code: row.item.stateDestination };
    this.form.priceListStateFrom = { name: row.item.stateOriginName, code: row.item.stateOrigin };
    this.form.priceListZoneTo = {
      zoneZc: row.item.zoneZcDestination,
      description: row.item.zoneZcDestinationDescription
    };
    this.form.priceListZoneFrom = { zoneZc: row.item.zoneZcOrigin, description: row.item.zoneZcOriginDescription };
    this.form.id = row.item.id;
    this.form.modelWeight = {
      id: row.item.weightUnit,
      code: row.item.weightUnitCode,
      description: row.item.weightUnitDescription
    };
    this.form.modelVolume = {
      id: row.item.volumeUnit,
      code: row.item.volumeUnitCode,
      description: row.item.volumeUnitDescription
    };

    this.form.modelReporteIn = this.reportedList.filter((reported: any) => reported.code == row.item.reportedIn);

    this.form.priceListTaxes = [];
    this.form.status = row.item.active;
    for (const volumeTax of row.item.taxes) {
      this.form.priceListTaxes.push({
        id: volumeTax.id,
        code: volumeTax.taxCode,
        description: volumeTax.taxName,
        percentage: volumeTax.taxPercentage
      });
    }
    this.isSave = false;
    this.setListTypeUpdate();
  }
  taxesWithRate({ description, percentage }: { description: string; percentage: string }) {
    return `${description} — [${percentage}%]`;
  }
  onTouch() {
    this.isTouched = true;
  }
  setListTypeUpdate() {
    if (this.$refs.formWizardPriceList.isLastStep) {
      this.form.priceListType = { description: 'weight', code: 'weight' };
    } else {
      this.form.priceListType = { description: 'volume', code: 'volume' };
    }
  }
  clearForm() {
    this.listroutestogether = {};
    this.route = {};
    this.form = {
      priceListCountryFrom: [],
      priceListCountryTo: [],
      priceListStateFrom: [],
      priceListStateTo: [],
      priceListZoneFrom: [],
      priceListZoneTo: [],
      priceListUnitValue: '',
      priceListMinRate: '',
      priceListType: [],
      priceListTaxes: [],
      dataTypeTransport: [],
      modelVolume: [],
      modelWeight: [],
      modelReporteIn: [],
      palletsFactor: '',
      status: true
    };
    this.provinceFrom = [];
    this.provinceTo = [];
    this.zonesFrom = [];
    this.zonesTo = [];
    this.$nextTick(() => this.$refs.validationPriceList.reset());
    this.$bvModal.hide('mdPriceList');
  }

  setListTypeSave() {
    if (this.$refs.formWizardPriceList.isLastStep) {
      this.clearForm();
      this.form.priceListType = { description: 'weight', code: 'weight' };
      this.isSave = true;
    } else {
      this.clearForm();
      this.form.priceListType = { description: 'volume', code: 'volume' };
      this.isSave = true;
    }
  }
  formatNameOrigin(objTerritory: any) {
    return `${objTerritory.countryOriginName} - ${objTerritory.stateOriginName} - ${objTerritory.cityOriginName} - ${objTerritory.zoneZcOrigin}`;
  }
  formatNameDestination(objTerritory: any) {
    return `${objTerritory.countryDestinationName} - ${objTerritory.stateDestinationName} - ${objTerritory.cityDestinationName} - ${objTerritory.zoneZcDestination}`;
  }

  formatCommodity(commodity: CommodityType) {
    return `${commodity.id} - ${commodity.description}`;
  }

  searchCustomers(query: string) {
    if (query.length >= 3) {
      const params: any = {
        text: query,
        type: ['SUPPLIER']
      };
      this.isLoading = true;
      this.findAllCustomersLike
        .execute(params)
        .then((response: any) => {
          this.customersList = response;
          this.isLoading = false;
        })
        .catch((error: any) => {
          this.isLoading = false;
          throw new Error(`${error}`);
        });
    }
  }

  getAllCommodityActive(asignateCommodity?: any) {
    this.isLoading = true;
    this.findCommodityByStatus
      .execute(true)
      .then((response: any) => {
        this.isLoading = false;
        this.commodityList = response;
        if (typeof asignateCommodity !== 'undefined') {
          this.form.commodity = this.commodityList.filter((item: any) => item.description === asignateCommodity)[0];
        }
      })
      .catch(error => {
        this.commodityList = [];
        this.isLoading = false;
        throw new Error(`${error}`);
      });
  }

  addTagCommodity(newTag: string) {
    this.form.commodity = { id: 0, description: newTag, active: true };
    this.isLoading = true;
    this.saveCommodityType
      .execute(this.form.commodity)
      .then((response: any) => {
        this.isLoading = false;
        if (response.ok) {
          this.getAllCommodityActive(newTag);
        }
      })
      .catch(error => {
        this.isLoading = false;
        this.form.commodity = '';
        throw new Error(`${error}`);
      });
  }

  manageSlidingScale() {
    if (this.form.slidingScaleTo < this.form.slidingScaleFrom) {
      this.form.slidingScaleTo = parseFloat(this.form.slidingScaleFrom);
    }
  }

  deleteCommodity(commodity: any) {
    this.isLoading = true;
    commodity.active = false;
    this.updateCommodity
      .execute(commodity)
      .then((response: any) => {
        this.isLoading = false;
        if (response.ok) {
          this.getAllCommodityActive();
          this.form.commodity = '';
        }
      })
      .catch(error => {
        this.isLoading = false;
        this.form.commodity = '';
        throw new Error(`${error}`);
      });
  }

  async findPricelistZones() {
    this.isLoading = true;
    const res = await this.findActivePricingZones.execute(true);
    this.pricingZonesList = res.length > 0 ? res : [];
    this.isLoading = false;
  }
}
